import AccountSetupList from './AccountSetupList';

export default AccountSetupList;
